import { render, staticRenderFns } from "./block-style1.vue?vue&type=template&id=47d29516&scoped=true&"
import script from "./block-style1.vue?vue&type=script&lang=js&"
export * from "./block-style1.vue?vue&type=script&lang=js&"
import style0 from "./block-style1.vue?vue&type=style&index=0&id=47d29516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d29516",
  null
  
)

export default component.exports